import {
    ApiUtils,
    _axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
    list: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/genj/listAllRcds", params, successCallback, failCallback, exceptionCallback);
    },
    tuisong: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/genj/listAllMsgs", params, successCallback, failCallback, exceptionCallback);
    },
    lsStuByMsg: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/genj/listStuByMsg", params, successCallback, failCallback, exceptionCallback);
    },
    addAllRcds: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/genj/addAllRcds", params, successCallback, failCallback, exceptionCallback);
    },
    listRcds: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/genj/listRcds", params, successCallback, failCallback, exceptionCallback);
    },
    addRcd: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/genj/addRcd", params, successCallback, failCallback, exceptionCallback);
    },
    save: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/xlstudent/listRcds", params, successCallback, failCallback, exceptionCallback);
    },
    toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/genj/toUpdate", params, successCallback, failCallback, exceptionCallback);
    },
    update: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.putLoadingAjax(constant.serverUrl + "/genj/update", params, successCallback, failCallback, exceptionCallback);
    },
    remove: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.deleteLoadingAjax(constant.serverUrl + "/genj/removeRecd", params, successCallback, failCallback, exceptionCallback);
    },
    upload: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/genj/upload", params, successCallback, failCallback, exceptionCallback);
    },
    autoSnmBymobile: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/signup/autoSnmBymobile", params, successCallback, failCallback, exceptionCallback);
    },
    mergeFP: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/genj/merge", params, successCallback, failCallback, exceptionCallback);
    }
}

export default api;